import type { BanDich } from '../../types';
import type { viRpaTongQuan } from './tong-quan.vi';

export const enRpaTongQuan: Pick<BanDich, keyof typeof viRpaTongQuan> = {
  rpaTongQuan: {
    moTa: 'Robot runs, success rate and Robot status by project — read from OpenRPA instances on OpenCore.',
    xuatCsv: 'Export CSV',
    daXuat: 'Exported the dashboard data.',
    locProject: 'Filter by project',
    moiProject: 'All projects',
    khoangNgay: 'Time range',
    soNgay: 'Last {{so}} days',
    thoiGianThuc: 'Refreshes every 30 seconds',
    khongLamMoiDuoc: 'Could not refresh; showing older figures',
    biCat: 'Reached the limit of {{so}} runs: older runs may be missing. Narrow the date range or pick one project.',
    kpiProject: 'Total projects',
    kpiRobot: 'Robots running',
    kpiThanhCong: 'Successful sessions',
    kpiTyLe: 'Rate {{tyLe}}%',
    kpiLoi: 'Failed sessions',
    kpiTyLeLoi: 'Failure rate {{tyLe}}%',
    theoNgay: 'Runs per day',
    tong: 'Total',
    thanhCong: 'Succeeded',
    loi: 'Failed',
    dangChay: 'Running',
    biDung: 'Stopped',
    moTaCot: '{{ngay}}: {{so}} runs',
    soLuotThe: '{{so}} runs',
    chuaCoDuLieu: 'No runs in this date range.',
    tyLeTieuDe: 'Success / failure rate',
    thanhCongNgan: 'succeeded',
    tyLeThanhCong: 'Success rate',
    tyLeLoi: 'Failure rate',
    tongPhien: 'Out of {{so}} sessions finished on OpenCore (runs stopped by hand are not counted)',
    chuaCoLuotXong: 'No run finished in this date range.',
    theoProject: 'Runs by project',
    theoProjectGoiY: 'Succeeded / Failed',
    okLoi: '{{ok}} / {{loi}}',
    moTaProject: '{{project}}: {{chiTiet}}',
    chuaCoProject: 'No runs by project yet.',
    chuaGanProject: 'No project',
    tinhTrangRobot: 'Robot status',
    chuaCoRobot: 'No Robot ran on OpenCore in this date range.',
    robot: {
      running: 'Running',
      idle: 'Ready',
      error: 'Last run failed',
      unknown: 'No operating data yet',
    },
    danhSachLuot: 'Robot runs',
    timLuot: 'Search project / flow / machine / error...',
    locTrangThai: 'Filter by status',
    moiTrangThai: 'All statuses',
    chuaCoLuot: 'No runs yet',
    chuaCoLuotMoTa: 'OpenRPA runs show up here once a Robot runs a workflow in the selected date range.',
    rongLoc: 'No runs match the filters',
    cotThoiGian: 'Time',
    cotProject: 'Project',
    cotWorkflow: 'Flow',
    cotThoiLuong: 'Duration',
    cotTrangThai: 'Status',
    dangChayNhan: 'running...',
    thoiLuongGio: '{{gio}} h {{phut}} min',
    thoiLuongPhut: '{{phut}} min {{giay}} s',
    thoiLuongGiay: '{{giay}} s',
    xemChiTiet: 'View error report',
    xemChiTietCua: 'View the error report of {{ten}}',
    tongTrang: '{{tu}}–{{den}} of {{tong}} runs',
    soLuotLoc: '{{so}} of {{tong}} runs match the filters',
    chuThichLuot: 'Runs read from OpenCore: up to the 200 latest in the selected date range.',
    csv: {
      instanceId: 'Instance ID',
      batDau: 'Started',
      ketThuc: 'Finished',
      project: 'Project',
      workflow: 'Workflow',
      may: 'Machine',
      trangThai: 'Status',
      thoiLuongMs: 'Duration (ms)',
      loi: 'Error',
    },
  },
};
